import { makeStyles, createStyles } from '@material-ui/core/styles';
import theme from 'styles/theme';

const useStyles = makeStyles(() =>
  createStyles({
    box: {
      zIndex: 10000,
      marginLeft: 64,
      '& button': {
        backgroundColor: 'transparent',
        '& svg': {
          color: '#FFFFFF',
          width: 12,
        },
      },
      '& .MuiButton-label': {
        color: theme.palette.grey[300],
        textTransform: 'capitalize',
        fontSize: 14,
      },
    },
    menuItem: {
      color: theme.palette.grey[300],
      borderRadius: 8,
      margin: '5px 10px',
    },
    menu: {
      '& .MuiPaper-root': {
        backgroundColor: theme.palette.primary.main,
        borderRadius: 10,
      },
    },
  }),
);

export default useStyles;
